import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconMusic",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.323 1.118a.5.5 0 0 1 .177.382V8a2 2 0 1 1-1-1.732V2.09l-5 .834V9a2 2 0 1 1-1-1.732V2.5a.5.5 0 0 1 .418-.493l6-1a.5.5 0 0 1 .405.111ZM4.5 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm6-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
  "clip-rule": "evenodd"
}, null, -1), u = [
  _
];
function m(e, f, i, p, h, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--music"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Music",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, u, 10, c);
}
const I = /* @__PURE__ */ n(o, [["render", m]]);
export {
  I as default
};
//# sourceMappingURL=music.js.map
